import React from "react";
import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <div className="page active">
      <h2 className="page-title">Contact Us</h2>
      <div className="contact-content">
        <ContactForm />

        <div className="contact-info">
          <h3 style={{ marginBottom: "20px"}}>Contact Information</h3>
          <div className="contact-item">
            <div className="contact-icon">📍</div>
            <div>
              <strong>Registered Address:</strong>
              <br />
              215, Reena Complex, Ramdev Pir Rd, opp Neelkanth Business
              Park,
              <br />
              Vidyavihar West, Mumbai, Maharashtra 400086,
              <br />
              Maharashtra, India
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">📞</div>
            <div>
              <strong>Phone:</strong>
              <br />
              WhatsApp : +91-9821341221
              <br />
              Office : +91-9920850545
              <br />
              Office Landline : +91-2235550545
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">📧</div>
            <div>
              <strong>Email:</strong>
              <br />
              devanshicorporation@gmail.com
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">🏦</div>
            <div>
              <strong>Banking Partners:</strong>
              <br />
              Union Bank
              <br />
              SVC Co-operative Bank Ltd
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">💳</div>
            <div>
              <strong>Payment Methods:</strong>
              <br />
              Cash, Credit Card, Cheque, DD
              <br />
              Online Transfer, Bank Transfer
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">🚚</div>
            <div>
              <strong>Shipping:</strong>
              <br />
              By Road, By Sea, By Air, By Cargo
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
